export const marketingCalloutComponent = {
  key: 'marketingCalloutComponent',
  name: 'Marketing Callout Dept-Component',
  siteIdentifier: 'global',

  marketingCalloutImageAlt: 'marketing callout',
};
